module.exports = __webpack_public_path__ + "static/media/people.f279d948.png";